import { inject, injectable } from 'tsyringe';
import { type IValuationEstimateRepository } from 'application/repositorySchemas/IValuationEstimateRepository';
import { type IValuationEstimateClient } from 'interfaceAdapter/gatewaySchemas/IValuationEstimateClient';

@injectable()
export class ValuationEstimateRepository implements IValuationEstimateRepository {
    constructor(
        @inject('IValuationEstimateClient')
        public readonly valuationEstimateClient: IValuationEstimateClient,
    ) {}

    public post = async (
        revenue_mjpy: number,
        operating_income_mjpy: number,
        depreciation_mjpy: number,
        cash_and_deposits_mjpy: number,
        interest_bearing_debt_mjpy: number,
        net_assets_mjpy: number,
        has_intellectual_property: boolean,
        ip_right_holder_type: string | null,
    ): Promise<{ lower: number; upper: number }> => {
        const { data, message } = await this.valuationEstimateClient.post({
            revenue_mjpy,
            operating_income_mjpy,
            depreciation_mjpy,
            cash_and_deposits_mjpy,
            interest_bearing_debt_mjpy,
            net_assets_mjpy,
            has_intellectual_property,
            ip_right_holder_type,
        });

        if (message) {
            throw new Error(message);
        }

        return {
            lower: data.lower,
            upper: data.upper,
        };
    };
}
